import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {SnackbarService} from '../../service/snackbar.service';

@Component({
    templateUrl: 'snackbar.component.html',
    styleUrls: ['snackbar.component.scss'],
    standalone: false
})
export class SnackbarComponent {
    style: SnackbarStyle;

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
        public snackbarService: SnackbarService,
    ) {
        this.style = data.style || 'success';
    }
}

export interface SnackbarData {
    // todo DEVCOID-1736: message and messageHtml are both optional, so the type does not enforce that exactly one is set.
    // DEVCOID-1736 drops the markup input entirely; if it lands on a compromise, constrain the pair in the type instead.
    message?: string;
    // rendered through [innerHTML]: the key and every translationParams value reach the DOM unsanitized.
    // The key MUST be an i18n constant; any runtime value in translationParams MUST be escaped by the caller.
    messageHtml?: string;
    isInfinite: boolean;
    style?: SnackbarStyle;
    translationParams?: Record<string, any>;
    commonsClickById?: Record<string, any>;
}

export type SnackbarStyle = 'success' | 'warning' | 'error';
